import { Component, HostListener, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { InfoHTRsvDTO } from 'src/app/models/InfoHTRsv';
import { MstUserDTO } from 'src/app/models/MstUser';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { RsvDateTimeDTO } from 'src/app/models/RsvDateTime';
import { ExamCourseSelDTO } from 'src/app/models/ExamCourseSel';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { IAppState } from 'src/app/store/states/app.state';
import { Store } from '@ngrx/store';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { SrcReservationDetailService } from '../src-reservation-detail/src-reservation-detail.service';
import { QueryParams } from 'src/app/shared/constant';
import { SrcExamCourseSelService } from '../src-exam-course-sel/src-exam-course-sel.service';
import { DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/helpers/app-init-config.service';
/* 20231006 add #19525 start */ 
import { CommonService } from './../../../../services/common.service';
/* 20231006 add #19525 end */ 

@Component({
  selector: 'app-src-reservation-detail',
  templateUrl: './src-reservation-detail.component.html',
  styleUrls: ['./src-reservation-detail.component.scss']
})
export class SrcReservationDetailComponent implements OnInit, DeactivateGuard {
  objRsv = new InfoHTRsvDTO();
  objUser = new MstUserDTO();
  objRsvDateTime = new RsvDateTimeDTO();
  objCourse = new ExamCourseSelDTO();
  isAgree = false;
  isMessAgree = false;
  isShowInsurence = false;
  HTOrgCode: any;
  RsvDate: any;
  RsvNum: any;
  typeMode = 1; // 1: add ; 2: edit confirm; 3: confirm
  dataReservation: any;
  ReqPriceFractionCalDiv: any;
  TaxRate: any;
  lstSetItemCancel: any[] = [];
  isShowKanaName = false;
  isRedirect = false;
  isRedirecting = false;
  CorrectAmount = 0;
  /* 20231006 add #19525 start */ 
  skipFlag = true;
  /* 20231006 add #19525 end */ 
  constructor(
    private router: Router,
    public util: Utility,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public trans: TranslateService,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
    private rsvDetailService: SrcReservationDetailService,
    private examCourseSelService: SrcExamCourseSelService,
    /* 20231006 add #19525 start */ 
    private common: CommonService,
    /* 20231006 add #19525 end */ 
  ) { }

  ngOnInit(): void {
    this.getTaxRate();
    this.util.resetZoomBrowser();
    this.preventButtonBackBrowser()
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    window.history.forward()
  }
  getDataInit() {
    const strMode = this.routeActived.snapshot.queryParams[QueryParams.Mode];
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (!this.util.isNullOrEmpty(dataLocal) && !this.util.isNullOrEmpty(strHTOrgCode)) {
      this.HTOrgCode = strHTOrgCode;
      this.typeMode = 1;
      const dataReservation = JSON.parse(dataLocal);
      if ((this.util.isNullOrEmpty(dataReservation.objRsv) && dataReservation.typeReservation === 1)
        || this.util.isNullOrEmpty(dataReservation.objUser)
        || this.util.isNullOrEmpty(dataReservation.objRsvDateTime) || this.util.isNullOrEmpty(dataReservation.objCourse)
        || (strMode !== ScreenMode.Edit && this.util.isNullOrBlank(dataReservation.typeReservation))) {
        this.loadingSrv.setDisplay(false);
        this.router.navigateByUrl('404');
        return;
      }
      this.dataReservation = dataReservation;
      this.setHTOrgName(dataReservation.HTOrgName);
      this.objRsv = dataReservation.objRsv;
      this.objUser = dataReservation.objUser;
      this.objRsvDateTime = dataReservation.objRsvDateTime;
      this.objCourse = dataReservation.objCourse;
      if (!this.util.isNullOrEmpty(dataReservation.isAgree)) {
        this.isAgree = dataReservation.isAgree;
      }
      if (this.objUser.CountryCode === 'JP') {
        this.isShowKanaName = true;
      }
      if (strMode === ScreenMode.Edit || strMode === ScreenMode.Confirm) {
        this.typeMode = strMode === ScreenMode.Edit ? 2 : 3;
        if (!this.util.isNullOrBlank(this.objRsv?.InsurerNum)) {
          this.isShowInsurence = true;
        }
        const strDate = this.routeActived.snapshot.queryParams[QueryParams.RsvDate];
        const strNum = this.routeActived.snapshot.queryParams[QueryParams.RsvNum];
        const HtOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
        if (!this.util.isNullOrBlank(strDate) && !this.util.isNullOrBlank(strNum) && !this.util.isNullOrBlank(HtOrgCode)) {
          this.RsvDate = strDate;
          this.RsvNum = strNum;
          this.HTOrgCode = HtOrgCode;
          if (strDate !== this.dataReservation?.objRsvDateTimeOld?.RsvYMD
            || strNum !== dataReservation.RsvNum || HtOrgCode !== strHTOrgCode) {
            this.getDetailRsv(true);
          } else {
            this.getDetailRsv(false);
          }
        } else {
          this.loadingSrv.setDisplay(false);
          this.router.navigateByUrl('404');
          return;
        }
      } else {
        this.isShowInsurence = dataReservation.typeReservation === 1 ? true : false;
        this.setTotalPrice();
      }
      if (this.typeMode === 1) {
        dataReservation.isReservationDetail = true;
        sessionStorage.setItem('DataReservation', JSON.stringify(dataReservation));
      }
    } else if (strMode === ScreenMode.Edit || strMode === ScreenMode.Confirm) {
      const strDate = this.routeActived.snapshot.queryParams[QueryParams.RsvDate];
      const strNum = this.routeActived.snapshot.queryParams[QueryParams.RsvNum];
      const strHtOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
      if (!this.util.isNullOrBlank(strDate) && !this.util.isNullOrBlank(strNum) && !this.util.isNullOrBlank(strHtOrgCode)) {
        this.typeMode = strMode === ScreenMode.Edit ? 2 : 3;
        this.RsvDate = strDate;
        this.RsvNum = strNum;
        this.HTOrgCode = strHtOrgCode;
        this.getDetailRsv(true);
      } else {
        this.loadingSrv.setDisplay(false);
        this.router.navigateByUrl('404');
        return;
      }
    } else {
      this.loadingSrv.setDisplay(false);
      this.router.navigateByUrl('404');
      return;
    }
    setTimeout(() => {
      this.util.addPerfectScrollBar();
      $('.scrollbar').scrollTop(0);
    }, 100);
  }
  getTaxRate() {
    this.loadingSrv.setDisplay(true);
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const strHtOrgCodePr = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    const objSearch = { HTOrgCode: !this.util.isNullOrBlank(strHtOrgCodePr) ? strHtOrgCodePr : strHTOrgCode };
    this.examCourseSelService.getTaxRate(objSearch).subscribe(data => {
      if (data) {
        this.TaxRate = data.TaxRate;
        this.ReqPriceFractionCalDiv = data.ReqPriceFractionCalDiv;
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.loadingSrv.setDisplay(false);
    }, () => {
      this.getDataInit();
    });
  }
  setHTOrgName(pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: pHTOrgName,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }
  getDetailRsv(isGetFull) {
    this.loadingSrv.setDisplay(true);
    const mailAdress = JSON.parse(localStorage.ExamineauthorizationData)?.MailAdress;
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      RsvDate: this.RsvDate,
      RsvNum: this.RsvNum,
    };
    this.rsvDetailService.getReservationDetail(objSearch).subscribe(data => {
      if (data && !this.util.isNullOrEmpty(data.InfoHTRsv)) {
        if (this.typeMode === 2 && data.IsEdit === false) {
          this.loadingSrv.setDisplay(false);
          this.router.navigateByUrl('404');
          return;
        }
        if (this.lstSetItemCancel && this.lstSetItemCancel.length > 0) {
          this.lstSetItemCancel = data.ListSetItemCancel;
        }

        if (isGetFull) {
          this.objUser = data.InfoHTRsv;
          this.objUser.MailAdress = mailAdress;
          this.objRsvDateTime.RsvTime = data.InfoHTRsv?.RsvTime;
          this.objRsvDateTime.RsvYMD = this.RsvDate;
          this.objCourse = data.MstHTCourse;
          if (data.ListOption && data.ListOption.length > 0) {
            this.objCourse.ListOption = data.ListOption;
          }
          this.dataReservation = {};
          this.dataReservation.objUser = this.objUser;
          this.dataReservation.objCourse = data.MstHTCourse;
          this.dataReservation.objRsvDateTime = this.objRsvDateTime;
          this.dataReservation.RsvNum = this.RsvNum;
          this.dataReservation.RsvDate = this.RsvDate;
          this.dataReservation.HTOrgName = data.HTOrgName;
          this.dataReservation.objRsvDateTimeOld = this.objRsvDateTime;
          /*20240523 modify #21672 start */
          this.dataReservation.objRsvDateTimeOld.ListOption = data.MstHTCourse.ListOption
          /*20240523 modify #21672  end */
          this.dataReservation.CountryCode = data.CountryCode;
          if (data.CountryCode === 'JP') {
            this.isShowKanaName = true;
          }
          this.setHTOrgName(data.HTOrgName);
          if (!this.util.isNullOrBlank(data.InfoHTRsv?.InsurerNum)) {
            this.isShowInsurence = true;
            this.objRsv = data.InfoHTRsv;
            this.dataReservation.objRsv = this.objRsv;
          }
        }
        this.setTotalPrice();
      } else {
        this.loadingSrv.setDisplay(false);
        this.router.navigateByUrl('404');
        return;
      }
      if (!this.util.isNullOrEmpty(this.TaxRate)) {
        this.loadingSrv.setDisplay(false);
      }
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    });
  }
  saveDataToSession() {
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (this.util.isNullOrEmpty(dataLocal)) {
      sessionStorage.setItem('HTOrgCode', this.HTOrgCode);
      sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      sessionStorage.setItem('DataReservationOld', JSON.stringify(this.dataReservation));
    }
    if (this.typeMode === 1) {
      sessionStorage.setItem('DataReservationOld', JSON.stringify(this.dataReservation));
    }
  }
  ButtonBack() {
    /*20240402 #21672 add start*/ 
    sessionStorage.removeItem('ObjCourseFirstDataReservation');
    sessionStorage.removeItem('selectedCourseFirst');
    /*20240402 #21672 add end*/
    /*20240724 #21672 add start*/ 
    sessionStorage.removeItem('ChangeDate');
    /*20240724 #21672 add end*/ 
    if (this.typeMode === 2 && this.checkDataChange()) {
      const strMess = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
      this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
        if (res.isOk()) {
          this.navigateToppage();
        }
      });
    } else {
      this.navigateToppage();
    }
  }
  convertPrice(value: any) {
    return this.util.calculateFormatCurrency(value, this.TaxRate, this.ReqPriceFractionCalDiv);
  }
  convertPriceItemCancel(value: any) {
    const price = this.util.calculateFormatCurrency(value, this.TaxRate, this.ReqPriceFractionCalDiv);
    return parseInt(price, 0) > 0 ? '-' + price : price;
  }
  EditRsvDateTime() {
    this.isRedirecting = true;
    this.checkAccessRsv(1);
  }
  EditCourseOption() {
    this.isRedirecting = true;
    this.checkAccessRsv(2);
  }
  EditPersonInfo() {
    this.isRedirecting = true;
    this.checkAccessRsv(3);
  }
  EditInsuranceInfo() {
    this.isRedirecting = true;
    this.checkAccessRsv(4);
  }
  ButtonCancelRsv() {
    /*20240402 #21672 add start*/ 
    sessionStorage.removeItem('ObjCourseFirstDataReservation');
    sessionStorage.removeItem('selectedCourseFirst');
    /*20240402 #21672 add end*/ 
    if (this.typeMode === 1) {
      const strMess = this.trans.instant('MESS_WRN_RESV_WILLBE_CANCELLED_REGISNEW');
      this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
        if (res.isOk()) {
          this.isRedirecting = true;
          this.navigateToppage();
        }
      });
    } else {
      const objSearch = {
        HTOrgCode: this.HTOrgCode,
        RsvDate: this.RsvDate,
        RsvNum: this.RsvNum,
      };
      this.rsvDetailService.checkAccessRsv(objSearch).subscribe(data => {
        if (data > 0) {
          const strMess = this.trans.instant('MESS_HOSP_SIDE_ISMODIFYING_CANNOT_CHANGE');
          this.dialogModalService.openErrorModal(strMess);
        }
        else {
          const strMess = this.trans.instant('MESS_WRN_RESV_WILLBE_CANCELLED');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.deleteRsv();
            }
          });
        }
      });
    }
  }
  ButtonRegis() {
    /*20240402 #21672 add start*/ 
    sessionStorage.removeItem('ObjCourseFirstDataReservation');
    sessionStorage.removeItem('selectedCourseFirst');
    /*20240402 #21672 add end*/ 
    this.isMessAgree = false;
    if (!this.isAgree && this.typeMode === 1) {
      $('.content-box-detail').scrollTop($('.content-box-detail')[0]?.scrollHeight);
      this.isMessAgree = true;
      return;
    } else {
      this.loadingSrv.setDisplay(true);
      if (this.typeMode === 1) {
        this.checkDateRsv();
      } else {
        const dataLocal = sessionStorage.getItem('DataReservation');
        if (!this.util.isNullOrEmpty(dataLocal)) {
          if (this.dataReservation?.objRsvDateTimeOld?.RsvYMD !== this.objRsvDateTime.RsvYMD
            || this.dataReservation?.objRsvDateTimeOld?.RsvTime !== this.objRsvDateTime.RsvTime) {
            this.checkDateRsv();
          } else {
            this.UpdateReservation();
          }
        } else {
          const timeOut = AppConfigService.settings.timeOutClosePopup;
          this.dialogModalService.openSuccessModal(this.trans.instant('MESS_CMN_INF_REGIS_SUCCESS'));
          this.loadingSrv.setDisplay(false);
          setTimeout(() => {
            this.isRedirecting = true;
            this.navigateToppage();
          }, timeOut);
        }
      }
    }
  }
  getParamAddOrUpdate() {
    const objSave = {
      HTOrgCode: this.HTOrgCode,
      RsvDate: this.objRsvDateTime.RsvYMD,
      HTCourseCode: this.objCourse.HTCourseCode,
      RsvTime: this.objRsvDateTime.RsvTime,
      ConsulName: this.objUser.ConsulName,
      KanaName: this.objUser.KanaName,
      DateOfBirth: this.objUser.DateOfBirth,
      Gender: this.objUser.Gender,
      PhoneNum: this.objUser.PhoneNum,
      PostalCode: this.util.TrimAll(this.objUser.PostalCode),
      Adress1: this.objUser.Adress1,
      Adress2: this.objUser.Adress2,
      CoCode: this.objCourse.CoCode,
      PersonFamilyDiv: this.objRsv?.PersonFamilyDiv,
      InsurerNum: this.objRsv?.InsurerNum,
      InsuranceCardSign: this.objRsv?.InsuranceCardSign,
      InsuranceCardNum: this.objRsv?.InsuranceCardNum,
      InsuranceCardBranchNum: this.objRsv?.InsuranceCardBranchNum,
      WebRsvNote: this.objUser.WebRsvNote,
      ChangedData: this.typeMode === 1 ? false : true,
      ListInfoRsvOption: this.getListHTSetItemCode(),
      RsvNum: null,
      RsvDateOld: this.objRsvDateTime.RsvYMD,
      RsvNumOld: null,
    };
    return objSave;
  }
  registerReservation() {
    this.loadingSrv.setDisplay(true);
    const objSave = this.getParamAddOrUpdate();
    this.rsvDetailService.registerReservation(objSave).subscribe(data => {
      if (data && data.Success) {
        this.dialogModalService.openInfoModal(this.trans.instant('MESS_RESV_REGIS_DONE')).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirecting = true;
            this.navigateToppage();
          }
        });
      } else {
        this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_REGIS_FAILED'));
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_REGIS_FAILED'));
      this.loadingSrv.setDisplay(false);
    });
  }
  UpdateReservation() {
    const objSave = this.getParamAddOrUpdate();
    objSave.RsvNum = this.RsvNum;
    objSave.RsvDateOld = this.dataReservation?.objRsvDateTimeOld?.RsvYMD;
    objSave.RsvNumOld = this.dataReservation?.RsvNum;
    this.rsvDetailService.UpdateReservation(objSave).subscribe(data => {
      if (data && data.Success) {
        if (data.Data === '0501') {
          const strMess = this.trans.instant('MESS_WRN_RESV_CHANGED_QUESTIONAIRE_WILLBE_CHANGED');
          this.dialogModalService.openInfoModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              /* 20240115 add #20979 start */ 
              /* �\������ύX�̏ꍇ */ 
              if(objSave.RsvDate != objSave.RsvDateOld){
                this.rsvDetailService.getRsvNum(objSave).subscribe(data => {
                  this.setHTOrgName('');
                  this.isRedirecting = true;
                  this.router.navigate(['scr-questionare-ans-inp'], {
                    queryParams: {
                      rsvdate: objSave.RsvDate,
                      rsvnum: data.InfoHTRsv?.RsvNum,
                      htorgcode: this.HTOrgCode
                    }
                  });                  
                }, err => {
                  this.dialogModalService.openErrorModal(this.trans.instant('MESS_EXCEPTION_OCCURRED'));
                  this.loadingSrv.setDisplay(false);
                });
              }
              else{
                this.setHTOrgName('');
                this.isRedirecting = true;
                this.router.navigate(['scr-questionare-ans-inp'], {
                  queryParams: {
                    rsvdate: this.RsvDate,
                    rsvnum: this.RsvNum,
                    htorgcode: this.HTOrgCode
                  }
                });
              }
              /* 20240115 add #20979 end */            
            }
          });
        } else {
          const timeOut = AppConfigService.settings.timeOutClosePopup;
          this.dialogModalService.openSuccessModal(this.trans.instant('MESS_CMN_INF_REGIS_SUCCESS'));
          this.loadingSrv.setDisplay(false);
          setTimeout(() => {
            this.isRedirecting = true;
            this.navigateToppage();
          }, timeOut);
        }
      } else if (data && data.StatusCode === 403) {
        const strMess = this.util.stringFormat([this.trans.instant('MESS_ERR_APPLICAPLE_DATA_NOT_EXIST'),
        this.trans.instant('STR_RSV_INFO')]);
        this.dialogModalService.openErrorModal(strMess).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirecting = true;
            this.navigateToppage();
          }
        });
      } else {
        this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_REGIS_FAILED'));
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_REGIS_FAILED'));
      this.loadingSrv.setDisplay(false);
    });
  }
  navigateToppage() {
    this.setHTOrgName('');
    this.removeDataToSession();
    this.router.navigateByUrl('/');
  }
  removeDataToSession() {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
  }
  changeAgree() {
    this.dataReservation.isAgree = this.isAgree;
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    if (this.isAgree) {
      this.isMessAgree = false;
    }
  }
  deleteRsv() {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      RsvDate: this.RsvDate,
      RsvNum: this.RsvNum,
    };
    this.rsvDetailService.deleteReservation(objSearch).subscribe(data => {
      if (data && data.Success) {
        this.isRedirecting = true;
        this.navigateToppage();
      } else if (data && data.StatusCode === 403) {
        const strMess = this.util.stringFormat([this.trans.instant('MESS_ERR_APPLICAPLE_DATA_NOT_EXIST'),
        this.trans.instant('STR_RSV_INFO')]);
        this.dialogModalService.openErrorModal(strMess).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirecting = true;
            this.navigateToppage();
          }
        });
      } else {
        this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    });
  }
  setTotalPrice() {
    const calcTotalPrice = this.util.calcTotalPrice(this.objCourse, this.objCourse?.ListOption, this.lstSetItemCancel);
    this.objCourse.TotalPrice = calcTotalPrice.TotalPrice;
    this.CorrectAmount = calcTotalPrice.CorrectAmount;
  }
  getListHTSetItemCode() {
    const lstOption = [];
    this.objCourse?.ListOption?.forEach(element => {
      lstOption.push(element.HTSetItemCode);
    });
    return lstOption;
  }
  checkDateRsv() {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      StartDate: this.objRsvDateTime.RsvYMD,
      EndDate: this.objRsvDateTime.RsvYMD,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.dataReservation.objCourse?.HTCourseCode,
      CoCode: this.dataReservation.objCourse?.CoCode,
      HTSetItemCode: this.getListHTSetItemCode(),
      RsvTime: this.objRsvDateTime.RsvTime,
      DateOfBirth: this.objUser.DateOfBirth,
    };
    this.rsvDetailService.checkDateTimeRsv(objSearch).subscribe(data => {
      if (data && data.length > 0) {
        if (this.typeMode === 1) {
          this.registerReservation();
        } else {
          this.UpdateReservation();
        }
      } else {
        this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_HAVETO_CHANGETO_ANOTHER_TIME'));
        this.loadingSrv.setDisplay(false);
      }
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    }, () => {
    });
  }
  checkAccessRsv(typeScreen: any) {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      RsvDate: this.RsvDate,
      RsvNum: this.RsvNum,
    };
    this.rsvDetailService.checkAccessRsv(objSearch).subscribe(data => {
      if (data > 0) {
        const strMess = this.trans.instant('MESS_HOSP_SIDE_ISMODIFYING_CANNOT_CHANGE');
        this.dialogModalService.openErrorModal(strMess);
      } else {
        this.saveDataToSession();
        switch (typeScreen) {
          case 1:
            this.router.navigateByUrl('reservation-date-sel?mode=edit');
            break;
          case 2:
            this.router.navigateByUrl('exam-course-sel?mode=edit');
            break;
          case 3:
            this.router.navigateByUrl('personal-inf-inp?mode=edit');
            break;
          case 4:
            this.router.navigateByUrl('insurance-inp?mode=edit');
            break;
          default:
            break;
        }
      }
      /* 20231006 add #19525 start */ 
      this.getDetailRsv(false);
      this.skipFlag = false;
      /* 20231006 add #19525 end */ 
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
  }
  /* 20231006 add #19525 start */ 
  async deleteConcurrent() {
    const pConcurrent = {
      KeyDate: this.RsvDate,
      KeyNum: this.RsvNum,
      HtOrgCode: this.HTOrgCode,
      ScreenDiv: '0'
    };
    await this.common.DeleteConcurent(pConcurrent).toPromise();
  }
  /* 20231006 add #19525 end */ 
  checkDataChange() {
    const dataLocal = sessionStorage.getItem('DataReservation');
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    if (!this.util.isNullOrBlank(dataLocal) && !this.util.isNullOrBlank(dataLocalOld)
      && dataLocal !== dataLocalOld) {
      return true;
    } else {
      return false;
    }
  }
  // Show poup when change data
  setDeactivateState(nextState) {
    if (this.isRedirecting) {
      this.isRedirect = true;
    }
    else {
      const checkChange = this.checkDataChange();
      if (checkChange || this.typeMode === 1) {
        const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.router.navigate([nextState]);
          }
        });
      } else {
        this.isRedirect = true;
      }
    }
  }
  // Show poup when change data
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isRedirect;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.checkDataChange() || this.typeMode === 1) {
      return false;
    } else {
      return true;
    }
  }
  private preventButtonBackBrowser() {
    history.pushState(null,"", location.href);
  }
  /* 20231006 add #19525 start */ 
  @HostListener('window:unload', ['$event'])
  unload(event: Event) {
    this.deleteConcurrent();
  }

  ngOnDestroy(): void {
    if (this.skipFlag) this.deleteConcurrent();
  }
  /* 20231006 add #19525 end */  
}
